export default function AppPageIntro({
  eyebrow,
  title,
  description,
  badges = [],
  action = null,
  icon: Icon = null,
  compact = false,
}) {
  return (
    <section className={`app-page-intro liquid-glass-surface relative overflow-hidden ring-1 ring-white/70 ${compact ? 'rounded-[28px] p-4 sm:p-5' : 'rounded-[32px] p-5 sm:p-6'}`}>
      <div className="app-page-intro-glow pointer-events-none absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-primary/10 via-accent/20 to-transparent" />
      <div className={`app-page-intro-topglow pointer-events-none absolute inset-x-0 top-0 bg-gradient-to-b from-white/70 to-transparent ${compact ? 'h-14' : 'h-20'}`} />
      <div className={`relative flex flex-col lg:flex-row lg:items-end lg:justify-between ${compact ? 'gap-3' : 'gap-5'}`}>
        <div className="min-w-0">
          <div className={`flex items-start ${compact ? 'gap-3' : 'gap-4'}`}>
            {Icon ? (
              <div className={`app-page-intro-icon liquid-glass-subtle hidden shrink-0 items-center justify-center rounded-2xl text-primary sm:flex ${compact ? 'h-12 w-12' : 'h-14 w-14'}`}>
                <Icon className={compact ? 'h-6 w-6' : 'h-7 w-7'} />
              </div>
            ) : null}
            <div className="min-w-0">
          {eyebrow && (
            <div className={`app-page-intro-eyebrow liquid-glass-subtle inline-flex items-center rounded-full px-3 py-1 text-xs font-medium tracking-wide text-slate-600 ${compact ? 'mb-2' : 'mb-3'}`}>
              {eyebrow}
            </div>
          )}
              <h1 className={`app-page-intro-title font-heading font-bold tracking-tight text-foreground ${compact ? 'text-2xl sm:text-3xl' : 'text-3xl sm:text-4xl'}`}>
                {title}
              </h1>
              {description && (
                <p className={`app-page-intro-description max-w-3xl text-muted-foreground ${compact ? 'mt-2 text-sm leading-5' : 'mt-2 text-sm leading-6 sm:text-base'}`}>
                  {description}
                </p>
              )}
              {badges.length > 0 && (
                <div className={`flex flex-wrap gap-2 ${compact ? 'mt-3' : 'mt-4'}`}>
                  {(compact ? badges.slice(0, 2) : badges).map((badge) => (
                    <span
                      key={badge}
                      className="app-page-intro-badge liquid-glass-subtle inline-flex items-center rounded-full px-3 py-1 text-xs font-medium text-slate-700"
                    >
                      {badge}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {action ? (
          <div className="flex shrink-0 items-center justify-start lg:justify-end">
            {action}
          </div>
        ) : null}
      </div>
    </section>
  );
}
